import React from 'react'
import { StatusWrapper, AccountSiteName, Actions } from '../../Components/TableActions'
import { createExpandedRowComponent } from 'packages/ui/Table'

export const ExpandedRowDetails = createExpandedRowComponent((item, t) => [
  {
    key: 'type',
    label: t('audin_document.table.reports.header.type'),
    value: (() => {
      const typeKeys = {
        'financial_report': t('documents.edition.types.financial_report'),
        'indicator_report': t('documents.edition.types.indicator_report'),
        'support_document': t('documents.edition.types.support_material'),
        'other': t('documents.edition.types.others')
      }
      return typeKeys[item.document_type] || item.document_type
    })()
  },
  {
    key: 'account',
    label: t('audin_document.table.reports.header.account'),
    value: item.wifirstsite?.organism?.name || '-'
  },
  {
    key: 'updated_at',
    label: t('audin_document.table.reports.header.updated_at'),
    value: item.updated_at || '-'
  },
  {
    key: 'format',
    label: t('audin_document.table.reports.header.form'),
    value: (() => {
      const contentType = (item.content_type || '').toUpperCase()
      if (contentType.includes('VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET')) {
        return 'XLS / XLSX'
      }
      return contentType.split('/').pop()
    })()
  }
])

const COLUMNS_CONFIG_CENTER = [
  {
    name: 'step',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.status')
    },
    value: (item) => <StatusWrapper step={item.step} uppercase={false} isCenterDocument={true} />,
    sortBy: 'step',
    sortable: true,
    style: { width: '5%' },
    priority: 1
  },
  {
    name: 'label',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.label')
    },
    value: item => item.name,
    sortBy: 'name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 1
  },
  {
    name: 'type',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.type')
    },
    value: (item, ctx) => {
      const typeKeys = {
        'financial_report': ctx.t('documents.edition.types.financial_report'),
        'indicator_report': ctx.t('documents.edition.types.indicator_report'),
        'support_document': ctx.t('documents.edition.types.support_material'),
        'other': ctx.t('documents.edition.types.others')
      };
      return typeKeys[item.document_type] || item.document_type;
    },
    sortBy: 'type',
    sortable: true,
    style: { width: '15%' },
    priority: 3
  },
  {
    name: 'account',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.account')
    },
    value: item => <AccountSiteName item={item} isAccount={true} />,
    sortBy: 'wifirstsite.organism.name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 4
  },
  {
    name: 'site_name',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.site_name')
    },
    value: (item, ctx) => (
      <AccountSiteName
        item={item}
        isAccount={false}
        onClick={() => ctx.onSiteClick && ctx.onSiteClick(item)}
      />
    ),
    sortBy: 'wifirstsite.name.raw',
    sortable: true,
    style: { width: '15%' },
    priority: 1
  },
  {
    name: 'created_at',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.created_at')
    },
    value: item => item.created_at,
    sortBy: 'created_at',
    sortable: true,
    style: { width: '7%' },
    priority: 2
  },
  {
    name: 'updated_at',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.updated_at')
    },
    value: item => item.updated_at,
    sortBy: 'updated_at',
    sortable: true,
    style: { width: '8%' },
    priority: 4
  },
  {
    name: 'format',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.form')
    },
    value: (item) => {
      const contentType = (item.content_type || '').toUpperCase()
      if (contentType.includes('VND.OPENXMLFORMATS-OFFICEDOCUMENT.SPREADSHEETML.SHEET')) {
        return 'XLS / XLSX'
      }
      return contentType.split('/').pop()
    },
    sortBy: 'format',
    sortable: true,
    style: { width: '5%' },
    priority: 3
  },
  {
    name: 'actions',
    header: {
      label: ctx => ctx.t('audin_document.table.reports.header.actions')
    },
    value: item => <Actions item={item} />,
    style: { width: '10%' },
    valueStyle: { textAlign: 'end' },
    priority: 1
  }
]

export default COLUMNS_CONFIG_CENTER